<template>
  <div>
    <az-back-button
      :route="{name: 'licitacao', params: {id: licitacaoId}, query: {edicao: true}}"
      text="Voltar para a licitação">
    </az-back-button>
    <az-container>
      <licitacao-atualizacao-acoes :ocorrencia="true"></licitacao-atualizacao-acoes>
      <div class="az-form-content">
        <v-card-text class="az-form-content pa-0">
          <v-layout wrap align-center white class="pa-3">
            <v-flex xs12 sm6 d-flex pr-2>
              <v-select
                name="Licitação"
                key="Licitação"
                label="Licitação"
                placeholder="Selecione a Ocorrência da Licitação"
                :menu-props="{ top: false, offsetY: true }"
                v-model="tipoOcorrenciaLicitacao"
                class="required-field"
                :rules="[validarDecisao]"
                v-validate="'required'"
                :items="converterEnumParaSelect(tiposOcorrenciaLicitacao)"
                :error-messages="errors.collect('Licitação')"
                item-text="texto"
                item-value="valor"
                clearable
              />
            </v-flex>
            <v-flex xs12 sm6 d-flex pl-2>
              <v-select
                name="Decisão"
                key="Decisão"
                label="Decisão"
                placeholder="Selecione a Decisão da Licitação"
                :menu-props="{ top: false, offsetY: true }"
                v-model="tipoDecisaoOcorrencia"
                :class="{'required-field': campoObrigatorio}"
                v-validate="campoObrigatorio ? 'required' : ''"
                :items="converterEnumParaSelect(tiposDecisaoOcorrencias)"
                :error-messages="errors.collect('Decisão')"
                item-text="texto"
                item-value="valor"
                clearable
              />
            </v-flex>
            <v-flex xs12 sm12 d-flex v-if="!exibirTabelaOcorrencias">
              <v-textarea
                v-model="descricao"
                class="required-field"
                v-validate="'required'"
                rows="2"
                name="Justificativa"
                key="Justificativa"
                label="Justificativa"
                placeholder="Insira a Justificativa"
                :error-messages="errors.collect('Justificativa')"
                :counter="5000"
                maxlength="5000"
              />
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-data-table
          v-if="exibirTabelaOcorrencias"
          :headers="headers"
          :items="lotes"
          item-key="loteId"
          v-model="selecionados"
          select-all
          class="elevation-0 tabela-ocorrencias"
          hide-actions
          no-data-text="Nenhum item/grupo Deserto/Fracassado.">
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td class="col-checkbox">
                <v-checkbox
                  v-model="props.selected"
                  hide-details
                  class="ma-0 pa-0"
                />
              </td>
              <td>{{ props.item.loteDescricao }}</td>
              <td>
                <expandir-texto :texto="codigoDescricao(props.item)" tamanho="75"></expandir-texto>
              </td>
              <td>{{ props.item.resultado }}</td>
              <td>
                <v-textarea
                  v-model="props.item.justificativa"
                  rows="1"
                  class="required-field"
                  v-validate="'required'"
                  :name="'justificativa-' + props.item.loteDescricao"
                  :key="'justificativa-' + props.item.loteDescricao"
                  placeholder="Insira a Justificativa"
                  :error-messages="errors.collect('justificativa-' + props.item.loteDescricao)"
                  :counter="5000"
                  maxlength="5000"
                />
              </td>
            </tr>
          </template>
        </v-data-table>

        <div class="az-actions-form" slot="actions">
          <div class="align-left">
            <button class="action-secundary" @click="voltarParaLicitacao">CANCELAR</button>
          </div>
          <div class="align-right">
            <button class="action-primary" @click="enviarOcorrencia">ENVIAR</button>
          </div>
        </div>
      </div>
    </az-container>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {actionTypes, tiposDecisaoOcorrencias, tiposOcorrenciaLicitacao} from '@/commons/constants'
import LicitacaoAtualizacaoAcoes from './LicitacaoAtualizacaoAcoes.vue'
import ModalPropostasExcluidas from "@/views/licitacao/detalhe/orgao/components/ModalPropostasExcluidas.vue";
import ExpandirTexto from "@/commons/components/ExpandirTexto.vue";

export default {
  name: 'LicitacaoAtualizacaoAcoesOcorrenciasEnviar',
  components: {ExpandirTexto, ModalPropostasExcluidas, LicitacaoAtualizacaoAcoes},
  created() {
    this.buscarLicitacao(this.$route.params.id)
  },
  data() {
    return {
      licitacaoId: this.$route.params.id,
      tiposDecisaoOcorrencias,
      tiposOcorrenciaLicitacao,
      tipoOcorrenciaLicitacao: '',
      tipoDecisaoOcorrencia: '',
      descricao: '',
      campoObrigatorio: false,
      selecionados: [],
      headers: [
        { text: 'Tipo', value: 'tipo', width: '80px', sortable: false },
        { text: 'Código/Descrição', value: 'codigoDescricao', width: '350px', sortable: false },
        { text: 'Resultado', value: 'resultado', width: '100px', sortable: false },
        { text: 'Justificativa', value: 'justificativa', width: '400px', sortable: false }
      ],
      lotes: [],
    }
  },
  computed: {
    ...mapState(["licitacao"]),
    exibirTabelaOcorrencias() {
      return [3, 4].includes(this.tipoOcorrenciaLicitacao)
    },
    ehFormularioValido() {
      return this.errors.items.length === 0
    },
  },
  methods: {
    codigoDescricao(item) {
      return item.itemCodigo && item.itemDescricao
        ? `${item.itemCodigo} - ${item.itemDescricao}`
        : '--'
    },
    converterEnumParaSelect(enumArray) {
      return enumArray.map(item => ({
        valor: Array.isArray(item.codigo) ? item.codigo[0] : item.codigo,
        texto: item.texto
      }))
    },
    async enviarOcorrencia() {
      await this.validarDadosFormulario()
      if (!this.ehFormularioValido) {
        this.mostrarNotificacaoErro("Preencha todos os campos obrigatórios")
        return
      }
      if (!this.validarLoteSelecionadoDesertoFracassado()) {
        this.mostrarNotificacaoErro('Selecione pelo menos um Tipo para enviar.')
        return
      }
      await this.inserirOcorrencia()
    },
    async inserirOcorrencia() {
      const payload = this.montarObjeto()
      const response = await this.inserirOcorrenciaEsfinge(payload)
      if (response.error) {
        this.mostrarNotificacaoErro(response.message)
        return
      }
      this.mostrarNotificacaoSucessoDefault()
      this.voltarParaLicitacao()
    },
    montarObjeto() {
      return {
        tipoDecisaoOcorrencia: this.tipoDecisaoOcorrencia,
        tipoOcorrenciaLicitacao: this.tipoOcorrenciaLicitacao,
        descricao: this.descricao,
        licitacaoId: this.licitacao.id,
        numeroEdital: this.licitacao.numeroEdital,
        lotes: this.selecionados
      }
    },
    validarDecisao(value) {
      if (value) {
        const ocorrenciasNaoObrigatorias = [3, 4]
        const ocorrenciaSelecionada = this.tipoOcorrenciaLicitacao

        if (ocorrenciasNaoObrigatorias.includes(ocorrenciaSelecionada)) {
          return this.campoObrigatorio = false
        }
        return this.campoObrigatorio = true
      }
      return this.campoObrigatorio
    },
    async validarDadosFormulario() {
      return await this.$validator.validate()
    },
    validarLoteSelecionadoDesertoFracassado() {
      if (!this.exibirTabelaOcorrencias)
        return true
      if (this.selecionados.length === 0) {
        return false
      }
      return true
    },
    voltarParaLicitacao() {
      this.$router.push( { name: 'licitacao', params: {id: this.licitacaoId}, query: {edicao: true} })
    },
    ...mapActions([
      actionTypes.BUSCAR_LICITACAO,
      actionTypes.BUSCAR_LOTES_DESERTO_FRACASSADO_OCORRENCIA,
      actionTypes.INSERIR_OCORRENCIA])
  },
  watch: {
    async exibirTabelaOcorrencias(exibir) {
      if (exibir) {
        const data = await this.buscarLotesDesertoFracassadoOcorrenciaEsfinge(this.licitacaoId)
        this.lotes = data.lotes
        this.selecionados = this.lotes
        this.descricao = ''
      }
    }
  }
}
</script>

<style>
  .az-actions-form .align-right button.action-primary {
    background-color: #0067a5;
    border-color: #0067a5;
  }

  .az-actions-form .align-right button.action-primary:hover {
    background-color: #003b5c;
    border-color: #003b5c;
  }

  table.v-table thead th.col-checkbox {
    padding: 0 !important;
  }

  table.v-table tbody td.col-checkbox {
    padding: 0 !important;
  }

  .tabela-ocorrencias table.v-table thead th,
  .tabela-ocorrencias table.v-table thead td,
  .tabela-ocorrencias table.v-table tbody th,
  .tabela-ocorrencias table.v-table tbody td {
    padding: 0 12px !important;
  }

  .col-checkbox {
    width: 10px;
  }
</style>